/* Rheinkauf – Warenkorb (Paket C, 10/2026)

   Wird auf jeder Seite geladen (snippets/cart-drawer.liquid), zusätzlich von der Warenkorbseite
   und von snippets/rk-addons.liquid – läuft trotzdem nur einmal. Kein Modul, keine Abhängigkeiten.
   Nutzt aus dem Theme: cart.js (cart-drawer, cart-items, sectionsToRender), global.js
   (trapFocus, updateCartCounters, PUB_SUB_EVENTS), pubsub.js (subscribe, publish).

   1. Neuzeichnen: <rk-warenkorb-stand> steht in den Bereichen, die das Theme nach jeder Änderung
      neu zeichnet (#CartDrawer-Body, <cart-items>). Wird es neu eingefügt, ist der Warenkorb neu
      gezeichnet worden:
      - Ansage über die Live-Region (was passiert ist, Anzahl, Zwischensumme, Versandhinweis),
      - Fokus zurück auf dasselbe Bedienelement derselben Zeile; nach „Entfernen“ auf die
        Überschrift, nach „Passt dazu“ auf „Passt dazu“,
      - Fokusfalle der offenen Schublade neu aufbauen (trapFocus merkt sich das erste und letzte
        Element – nach dem Neuzeichnen sind das neue Elemente),
      - Bestellhinweis: getippten Text und Auf-/Zu-Zustand wiederherstellen.
   2. „Passt dazu“ (<rk-passt-dazu>): füllt mit Shopify-Empfehlungen auf (intent complementary,
      dann related; sections/rk-warenkorb-empfehlungen.liquid), höchstens data-max Zeilen, nichts
      aus dem Warenkorb, nichts doppelt. „Hinzufügen“ legt per POST /cart/add.js in den Warenkorb
      (Ladezustand „Wird hinzugefügt …“, Erfolgszustand „Hinzugefügt“) und lässt das Theme den
      Warenkorb neu zeichnen – mit denselben Abschnitten wie assets/cart.js.
   3. Bestellhinweis: speichert per POST /cart/update.js (note), meldet „Gespeichert.“.
   4. Klick-Feedback (Vorbild WSTND wstnd-tap-feedback / wstnd-cart-feedback): Druckzustand auf
      allen Warenkorb-Knöpfen; „Wird hinzugefügt …“ / „Hinzugefügt“ auch auf den
      In-den-Warenkorb-Knöpfen des Themes (Produktseite, Leiste, Karten).
   5. Theme-Fix: Das Warenkorbsymbol im Kopf behält beim Neuzeichnen seine Hülle (sectionsToRender
      ersetzte sonst den ganzen Link-Inhalt).
   6. Theme-Fix: CartDrawer.renderContents ersetzt die Abschnitte wie CartItems.updateQuantity
      (Warenkorbseite bleibt nach einem Hinzufügen bedienbar, fehlende Abschnitte ohne Fehler). */

(function () {
  'use strict';

  if (window.rkWarenkorb) return;
  var RK = (window.rkWarenkorb = { version: 2 });

  var TEXT = {
    laedt: 'Wird hinzugefügt …',
    fertig: 'Hinzugefügt',
    fehlerAdd: 'Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es erneut.',
    leer: 'Ihr Warenkorb ist jetzt leer.',
    hinweisGespeichert: 'Gespeichert.',
    hinweisFehler: 'Der Hinweis konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    hinweisNeu: 'Bestellhinweis hinzufügen',
    hinweisAendern: 'Bestellhinweis ändern'
  };

  /* ------------------------------------------------------------------ Hilfen */

  function alle(sel, wurzel) {
    return Array.prototype.slice.call((wurzel || document).querySelectorAll(sel));
  }

  function routen() {
    return window.routes || {};
  }

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function drawerOffen() {
    var d = drawerEl();
    return !!(d && d.classList.contains('is-visible'));
  }

  /* <cart-items> gibt es nur auf der Warenkorbseite (die Schublade nutzt <cart-drawer-items>). */
  function seiteEl() {
    return document.querySelector('cart-items');
  }

  function sichtbar(liste) {
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].getClientRects().length) return liste[i];
    }
    return null;
  }

  function postJson(url, daten) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(daten)
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (json) {
          return { ok: res.ok, json: json || {} };
        });
    });
  }

  function zaehlerAktualisieren() {
    if (typeof updateCartCounters === 'function') {
      try {
        updateCartCounters();
      } catch (e) {
        /* nur Anzeige */
      }
    }
  }

  function melden(ereignis, daten) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS[ereignis]) return;
    try {
      publish(PUB_SUB_EVENTS[ereignis], daten);
    } catch (e) {
      /* Abonnenten des Themes dürfen uns nicht aufhalten */
    }
  }

  /* Zähler für alles, was den Warenkorb verändert. Ein verzögertes Neuzeichnen (nach dem
     Erfolgszustand) unterbleibt, wenn inzwischen eine neuere Änderung läuft. */
  var aenderung = 0;
  var zuletztBedient = 0;

  /* ------------------------------------------------------------------ Ansagen */

  var ansageTimer = null;

  function liveRegion() {
    var r = null;
    if (drawerOffen()) r = document.querySelector('[data-rk-live="drawer"]');
    if (!r) r = document.querySelector('[data-rk-live="seite"]');
    if (!r) r = document.querySelector('[data-rk-live="global"]');
    if (!r && document.body) {
      r = document.createElement('p');
      r.className = 'visually-hidden';
      r.setAttribute('role', 'status');
      r.setAttribute('aria-live', 'polite');
      r.setAttribute('data-rk-live', 'global');
      document.body.appendChild(r);
    }
    return r;
  }

  function ansagen(text) {
    if (!text) return;
    var r = liveRegion();
    if (!r) return;
    window.clearTimeout(ansageTimer);
    r.textContent = '';
    ansageTimer = window.setTimeout(function () {
      r.textContent = text;
    }, 120);
  }

  /* ------------------------------------------------------------------ Bedienung merken */

  var letzterFokus = null;
  var fokusVorher = null; /* letzterFokus beim Beginn des Neuzeichnens – cart.js setzt danach selbst Fokus */
  var vorspann = '';
  var fokusWunsch = null;
  var wunschZeit = 0; /* vorspann/fokusWunsch gelten nur für das nächste Neuzeichnen kurz danach */

  function wunschSetzen(text, fokus) {
    if (text !== null) vorspann = text;
    if (fokus !== null) fokusWunsch = fokus;
    wunschZeit = Date.now();
  }

  function bereichVon(el) {
    if (!el || !el.closest) return null;
    if (el.closest('cart-drawer')) return 'drawer';
    if (el.closest('cart-items')) return 'seite';
    return null;
  }

  document.addEventListener(
    'focusin',
    function (event) {
      var t = event.target;
      var bereich = bereichVon(t);
      if (!bereich) return;
      var zeile = t.closest('.cart-item[id]');
      letzterFokus = {
        bereich: bereich,
        zeile: zeile ? zeile.id : null,
        produkt: zeile ? zeile.getAttribute('data-rk-produkt') : null,
        name: t.getAttribute('name'),
        zeit: Date.now()
      };
    },
    true
  );

  function bedient(event) {
    if (bereichVon(event.target) || (event.target.closest && event.target.closest('rk-passt-dazu'))) {
      zuletztBedient = Date.now();
    }
  }

  document.addEventListener('click', bedient, true);
  document.addEventListener('keydown', bedient, true);

  /* Mengenänderung (cart.js hört auf change von updates[]) und Entfernen */
  document.addEventListener(
    'change',
    function (event) {
      if (event.target && event.target.name === 'updates[]' && bereichVon(event.target)) {
        aenderung++;
        zuletztBedient = Date.now();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var knopf = event.target && event.target.closest ? event.target.closest('cart-remove-button') : null;
      if (!knopf) return;
      aenderung++;
      var b = knopf.querySelector('[data-rk-entfernen]');
      var titel = b ? b.getAttribute('data-rk-entfernen') : '';
      wunschSetzen(titel ? '„' + titel + '“ wurde aus dem Warenkorb entfernt.' : 'Der Artikel wurde aus dem Warenkorb entfernt.', 'titel');
    },
    true
  );

  /* ------------------------------------------------------------------ Nach dem Neuzeichnen */

  var letzterStand = null;
  var letzteAnzahl = null;
  var geplant = null;
  var geaendert = false;
  var mehrArtikel = false;
  var startphase = true;
  var geoeffnetUm = 0;

  function standAnsagen() {
    var teile = [];
    if (vorspann) teile.push(vorspann);

    var d = drawerEl();
    var bereich = drawerOffen() ? d : seiteEl() || d;
    var stand = bereich ? bereich.querySelector('rk-warenkorb-stand') : null;

    if (stand) {
      var anzahl = parseInt(stand.getAttribute('data-anzahl'), 10) || 0;
      if (anzahl === 0) {
        teile.push(TEXT.leer);
      } else {
        teile.push('Warenkorb: ' + anzahl + ' Artikel, Zwischensumme ' + (stand.getAttribute('data-summe') || '') + '.');
        var vb = sichtbar(bereich.querySelectorAll('.rk-vb__text'));
        if (vb) teile.push(vb.textContent.replace(/\s+/g, ' ').trim());
      }
    }
    ansagen(teile.join(' '));
  }

  function gemerktesZiel(bereich) {
    var f = fokusVorher;
    if (!f || !f.zeile || Date.now() - f.zeit > 15000) return null;
    var zeile = document.getElementById(f.zeile);
    if (!zeile || !bereich.contains(zeile)) return null;
    if (f.produkt && zeile.getAttribute('data-rk-produkt') !== f.produkt) return null;
    if (f.name) {
      var el = zeile.querySelector('[name="' + f.name + '"]');
      if (el && !el.disabled) return el;
    }
    return null;
  }

  function wunschZiel(bereich) {
    if (fokusWunsch === 'addons') {
      var pd = bereich.querySelector('rk-passt-dazu:not(.is-leer) .rk-wa__kopf');
      if (pd) return pd;
    }
    return bereich.querySelector('[data-rk-fokus]');
  }

  function fokusPruefen() {
    var d = drawerEl();
    var offen = drawerOffen();
    var bereich = offen ? d : seiteEl();
    if (!bereich) return;

    /* Gerade geöffnet (z. B. Kaufen-Knopf der Produktseite): Den Fokus setzt das Theme nach der
       Einblend-Animation selbst auf „Schließen“ (siehe auch schubladeBeobachten). */
    if (offen && Date.now() - geoeffnetUm < 1200) return;

    var aktiv = document.activeElement;
    var verloren = !aktiv || aktiv === document.body || aktiv === document.documentElement || !aktiv.isConnected;
    var draussen = offen && aktiv && !verloren && !d.contains(aktiv);
    var falscheZeile = false;

    /* cart.js setzt den Fokus über die Zeilennummer – steht dort nach „Entfernen“ ein anderes
       Produkt, gehört der Fokus nicht dorthin. */
    if (!verloren && !draussen && fokusVorher && fokusVorher.produkt && bereich.contains(aktiv)) {
      var z = aktiv.closest('.cart-item[id]');
      if (z && z.getAttribute('data-rk-produkt') !== fokusVorher.produkt && fokusWunsch !== 'addons') falscheZeile = true;
    }

    var ziel = null;
    if (verloren || draussen || falscheZeile) {
      ziel = (fokusWunsch ? null : gemerktesZiel(bereich)) || wunschZiel(bereich);
    }

    if (offen) {
      var neu = ziel || (d.contains(aktiv) ? aktiv : d.querySelector('[data-drawer-close]'));
      if (typeof trapFocus === 'function' && d.firstElementChild && neu) {
        trapFocus(d.firstElementChild, neu);
      } else if (ziel) {
        ziel.focus();
      }
      return;
    }

    if (ziel && Date.now() - zuletztBedient < 6000) ziel.focus();
  }

  function nachNeuzeichnen() {
    geplant = null;
    var war = geaendert;
    var mehr = mehrArtikel;
    geaendert = false;
    mehrArtikel = false;
    if (Date.now() - wunschZeit > 10000) {
      vorspann = '';
      fokusWunsch = null;
    }

    fokusPruefen();
    if (war || vorspann) standAnsagen();
    if (mehr) themeKnoepfeFertig();
    hinweiseWiederherstellen();

    vorspann = '';
    fokusWunsch = null;
  }

  function planen() {
    if (geplant) return;
    fokusVorher = letzterFokus;
    geplant = window.setTimeout(nachNeuzeichnen, 60);
  }

  if (!window.customElements.get('rk-warenkorb-stand')) {
    window.customElements.define(
      'rk-warenkorb-stand',
      class extends HTMLElement {
        connectedCallback() {
          var anzahl = parseInt(this.getAttribute('data-anzahl'), 10) || 0;
          var stand = anzahl + '|' + (this.getAttribute('data-summe') || '');
          if (startphase || letzterStand === null) {
            letzterStand = stand;
            letzteAnzahl = anzahl;
            return;
          }
          if (stand !== letzterStand) {
            geaendert = true;
            if (letzteAnzahl !== null && anzahl > letzteAnzahl) mehrArtikel = true;
            letzterStand = stand;
            letzteAnzahl = anzahl;
          }
          planen();
        }
      }
    );
  }

  /* ------------------------------------------------------------------ „Passt dazu“ */

  var empfehlungsCache = {};

  function empfehlungenLaden(basis, produktId, absicht) {
    var url =
      basis +
      '?product_id=' +
      encodeURIComponent(produktId) +
      '&limit=10&intent=' +
      encodeURIComponent(absicht) +
      '&section_id=rk-warenkorb-empfehlungen';

    if (!empfehlungsCache[url]) {
      empfehlungsCache[url] = fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (res) {
          return res.ok ? res.text() : '';
        })
        .catch(function () {
          return '';
        })
        .then(function (html) {
          if (!html) delete empfehlungsCache[url];
          return html;
        });
    }
    return empfehlungsCache[url];
  }

  if (!window.customElements.get('rk-passt-dazu')) {
    window.customElements.define(
      'rk-passt-dazu',
      class extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.zeigen();
          if (!this.getAttribute('data-absichten')) return;
          if (this.closest('cart-drawer')) {
            /* Schublade: erst beim Öffnen nachladen (siehe schubladeBeobachten) */
            if (drawerOffen()) this.fuellen();
          } else {
            window.setTimeout(function () {
              self.fuellen();
            }, 0);
          }
        }

        zeilen() {
          return this.querySelectorAll('[data-rk-wa-produkt]');
        }

        zeigen() {
          this.classList.toggle('is-leer', this.zeilen().length === 0);
        }

        fuellen() {
          if (this._gefuellt) return;
          this._gefuellt = true;

          var self = this;
          var max = parseInt(this.getAttribute('data-max'), 10) || 3;
          var basis = this.getAttribute('data-url');
          var quelle = this.getAttribute('data-quelle');
          var absichten = (this.getAttribute('data-absichten') || '')
            .split(',')
            .map(function (s) {
              return s.trim();
            })
            .filter(Boolean);

          if (!basis || !quelle || !absichten.length || this.zeilen().length >= max) return;

          var ausschluss = {};
          (this.getAttribute('data-ausschluss') || '').split(',').forEach(function (id) {
            if (id) ausschluss[id] = true;
          });

          Promise.all(
            absichten.map(function (a) {
              return empfehlungenLaden(basis, quelle, a);
            })
          ).then(function (antworten) {
            if (!self.isConnected) return;
            var liste = self.querySelector('.rk-wa__liste');
            if (!liste) return;

            alle('[data-rk-wa-produkt]', self).forEach(function (li) {
              ausschluss[li.getAttribute('data-rk-wa-produkt')] = true;
            });
            var anzahl = self.zeilen().length;
            var parser = new DOMParser();

            antworten.forEach(function (html) {
              if (!html || anzahl >= max) return;
              var doc = parser.parseFromString(html, 'text/html');
              alle('[data-rk-wa-vorschlaege] [data-rk-wa-produkt]', doc).forEach(function (li) {
                var id = li.getAttribute('data-rk-wa-produkt');
                if (anzahl >= max || !id || ausschluss[id]) return;
                ausschluss[id] = true;
                liste.appendChild(document.importNode(li, true));
                anzahl++;
              });
            });

            self.zeigen();
          });
        }
      }
    );
  }

  function schubladeBeobachten() {
    var d = drawerEl();
    if (!d || d._rkBeobachtet || typeof MutationObserver === 'undefined') return;
    d._rkBeobachtet = true;
    d._rkOffen = d.classList.contains('is-visible');
    new MutationObserver(function () {
      var offen = d.classList.contains('is-visible');
      if (offen && !d._rkOffen) {
        geoeffnetUm = Date.now();
        alle('rk-passt-dazu', d).forEach(function (el) {
          if (typeof el.fuellen === 'function') el.fuellen();
        });
        /* Sicherheitsnetz: Das Theme setzt den Fokus erst bei transitionend. Fällt die Animation
           weg (Bewegung reduziert), käme dieses Ereignis nie – dann hier nachholen. */
        window.setTimeout(function () {
          if (!d.classList.contains('is-visible')) return;
          if (d.contains(document.activeElement)) return;
          if (typeof d.focusOnCartDrawer === 'function') d.focusOnCartDrawer();
        }, 900);
      }
      d._rkOffen = offen;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  /* Abschnitte wie assets/cart.js: Warenkorbseite → <cart-items>, sonst die Schublade. */
  function abschnittsQuelle() {
    var seite = seiteEl();
    if (seite && document.getElementById('main-cart-items') && typeof seite.getSectionsToRender === 'function') {
      return { art: 'seite', el: seite };
    }
    var d = drawerEl();
    if (d && typeof d.getSectionsToRender === 'function' && typeof d.renderContents === 'function') {
      return { art: 'drawer', el: d };
    }
    return null;
  }

  /* Wie CartItems.updateQuantity in assets/cart.js */
  function abschnitteErsetzen(abschnitte, sections) {
    var parser = new DOMParser();
    abschnitte.forEach(function (a) {
      if (!a || !sections[a.section]) return;
      var ziel = document.querySelector(a.selector) || document.querySelector(a.id);
      var neu = parser.parseFromString(sections[a.section], 'text/html').querySelector(a.selector);
      if (ziel && neu) ziel.innerHTML = neu.innerHTML;
    });
  }

  /* Theme-Fix: CartDrawer.renderContents (assets/cart.js) ersetzte das Element der ID-Angabe –
     auf der Warenkorbseite die ganze Section – durch den INHALT von <cart-items>. Danach fehlte
     <cart-items> samt Mengen- und Entfernen-Logik (z. B. nach einem Schnellkauf auf /cart). Fehlte
     ein Abschnitt in der Antwort, brach die Methode mit einem Fehler ab. Jetzt wie
     CartItems.updateQuantity: erst der genaue Selektor, sonst die ID; fehlende Abschnitte werden
     übersprungen. Aufruf und Verhalten bleiben gleich (Zähler aktualisieren, Schublade öffnen,
     open = false lässt sie zu) – Paket B (Merkliste) ruft die Methode so auf. */
  function renderPatch() {
    if (!window.customElements || typeof window.customElements.whenDefined !== 'function') return;
    window.customElements.whenDefined('cart-drawer').then(function () {
      var Klasse = window.customElements.get('cart-drawer');
      if (!Klasse || !Klasse.prototype || Klasse.prototype._rkRender) return;
      Klasse.prototype._rkRender = true;
      Klasse.prototype.renderContents = function (response, open) {
        var abschnitte = typeof this.getSectionsToRender === 'function' ? this.getSectionsToRender() || [] : [];
        if (response && response.sections) abschnitteErsetzen(abschnitte, response.sections);
        zaehlerAktualisieren();
        if (open !== undefined && !open) return;
        this.open();
      };
    });
  }

  function addFehler(meldung, text) {
    var t = text || TEXT.fehlerAdd;
    if (meldung && meldung.getClientRects().length) {
      meldung.textContent = t;
    } else {
      ansagen(t);
    }
  }

  /* Kern: in den Warenkorb legen und das Theme den Warenkorb neu zeichnen lassen – mit denselben
     Abschnitten wie assets/cart.js (Warenkorbseite: Seite + Schublade + Kopf-Zähler; sonst die
     Schublade, die sich dabei öffnet). Liefert ein Promise mit { ok, json, meldung }.
     optionen.titel       – Produktname für die Ansage
     optionen.ausloeser   – Element, auf das der Fokus beim Schließen der Schublade zurückgeht
     optionen.vorher(ok)  – wird vor dem Neuzeichnen aufgerufen (z. B. Erfolgszustand zeigen)
     optionen.warten      – Millisekunden bis zum Neuzeichnen */
  function inDenWarenkorb(id, menge, optionen) {
    var o = optionen || {};
    var quelle = abschnittsQuelle();
    var abschnitte = quelle ? quelle.el.getSectionsToRender() || [] : [];
    var daten = { items: [{ id: id, quantity: menge || 1 }] };
    if (abschnitte.length) {
      daten.sections = abschnitte.map(function (a) {
        return a.section;
      });
      daten.sections_url = window.location.pathname;
    }

    var meine = ++aenderung;
    zuletztBedient = Date.now();

    return postJson((routen().cart_add_url || '/cart/add') + '.js', daten).then(function (antwort) {
      var json = antwort.json;
      if (!antwort.ok || json.status) {
        var text = json.description || json.message || '';
        melden('cartError', { source: 'rk-warenkorb', productVariantId: id, errors: text });
        return { ok: false, json: json, meldung: text };
      }

      melden('cartUpdate', { source: 'rk-warenkorb', productVariantId: id, cartData: json });
      if (typeof o.vorher === 'function') o.vorher(true);

      if (!quelle || !json.sections) {
        window.location.href = routen().cart_url || '/cart';
        return { ok: true, json: json, meldung: '' };
      }

      var darstellen = function () {
        if (meine !== aenderung) {
          /* Inzwischen läuft eine neuere Änderung – deren Antwort zeichnet neu. */
          zaehlerAktualisieren();
          return;
        }
        wunschSetzen(o.titel ? '„' + o.titel + '“ liegt jetzt im Warenkorb.' : 'Der Artikel liegt jetzt im Warenkorb.', o.imWarenkorb ? 'addons' : null);
        if (quelle.art === 'seite') {
          abschnitteErsetzen(abschnitte, json.sections);
          zaehlerAktualisieren();
        } else {
          var offen = drawerOffen();
          if (!offen && o.ausloeser && typeof quelle.el.setActiveElement === 'function') {
            quelle.el.setActiveElement(o.ausloeser);
          }
          quelle.el.renderContents(json, !offen);
        }
      };

      if (o.warten) {
        window.setTimeout(darstellen, o.warten);
      } else {
        darstellen();
      }
      return { ok: true, json: json, meldung: '' };
    });
  }

  function hinzufuegen(knopf) {
    if (knopf.getAttribute('aria-busy') === 'true') return;
    /* Im Warenkorb verschwindet die Zeile gleich – ein zweiter Klick im Erfolgszustand legte den
       Artikel sonst doppelt hinein. */
    if (knopf.classList.contains('rk-knopf--fertig') && knopf.closest('cart-drawer, cart-items')) return;

    var id = parseInt(knopf.getAttribute('data-rk-add'), 10);
    if (!id) return;
    var block = knopf.closest('rk-passt-dazu');
    var meldung = block ? block.querySelector('[data-rk-wa-meldung]') : null;
    var imWarenkorb = !!knopf.closest('cart-drawer, cart-items');

    if (meldung) meldung.textContent = '';
    knopfZustand(knopf, 'laedt');

    inDenWarenkorb(id, parseInt(knopf.getAttribute('data-rk-menge'), 10) || 1, {
      titel: knopf.getAttribute('data-rk-titel') || '',
      ausloeser: knopf,
      imWarenkorb: imWarenkorb,
      /* Im Warenkorb verschwindet die Zeile beim Neuzeichnen – den Erfolgszustand vorher kurz
         zeigen. Auf der Produktseite bleibt der Knopf stehen. */
      warten: imWarenkorb ? 700 : 0,
      vorher: function () {
        knopfZustand(knopf, 'fertig');
      }
    })
      .then(function (erg) {
        if (erg.ok) return;
        knopfZustand(knopf, null);
        addFehler(meldung, erg.meldung);
      })
      .catch(function () {
        knopfZustand(knopf, null);
        addFehler(meldung);
      });
  }

  document.addEventListener('click', function (event) {
    var knopf = event.target && event.target.closest ? event.target.closest('[data-rk-add]') : null;
    if (!knopf) return;
    event.preventDefault();
    hinzufuegen(knopf);
  });

  /* ------------------------------------------------------------------ Knopf-Zustände */

  function textZiel(knopf) {
    var el = knopf.querySelector('[data-rk-knopf-text]');
    if (el) return el;
    for (var i = 0; i < knopf.children.length; i++) {
      var c = knopf.children[i];
      if (c.tagName === 'SPAN' && !c.classList.contains('visually-hidden') && c.textContent.trim()) return c;
    }
    return null;
  }

  /* art: 'laedt' | 'fertig' | null (zurück). Der ursprüngliche Text kommt nur zurück, wenn ihn
     inzwischen niemand geändert hat (das Theme setzt ihn z. B. bei einem Variantenwechsel). */
  function knopfZustand(knopf, art) {
    var ziel = textZiel(knopf);
    var st = knopf._rkZustand;
    if (!st) {
      st = knopf._rkZustand = { original: ziel ? ziel.textContent : '', gesetzt: null, timer: null };
      /* „Passt dazu“-Knöpfe: Breite einfrieren, damit die längeren Zustandstexte die Zeile nicht
         verschieben (CSS lässt den Text darin umbrechen). */
      if (art && knopf.classList.contains('rk-wa__knopf') && knopf.offsetWidth) {
        knopf.style.width = knopf.offsetWidth + 'px';
      }
    }
    window.clearTimeout(st.timer);
    knopf.classList.remove('rk-knopf--laedt', 'rk-knopf--fertig');

    if (art === 'laedt' || art === 'fertig') {
      var text = art === 'laedt' ? TEXT.laedt : TEXT.fertig;
      knopf.classList.add('rk-knopf', art === 'laedt' ? 'rk-knopf--laedt' : 'rk-knopf--fertig');
      if (ziel) {
        ziel.classList.add('rk-knopf__text');
        ziel.textContent = text;
        st.gesetzt = text;
      }
      if (art === 'laedt') {
        knopf.setAttribute('aria-busy', 'true');
      } else {
        knopf.removeAttribute('aria-busy');
        st.timer = window.setTimeout(function () {
          knopfZustand(knopf, null);
        }, 2500);
      }
      return;
    }

    knopf.removeAttribute('aria-busy');
    if (ziel) {
      if (st.gesetzt !== null && ziel.textContent === st.gesetzt) ziel.textContent = st.original;
      ziel.classList.remove('rk-knopf__text');
    }
    knopf.style.width = '';
    knopf._rkZustand = null;
  }

  /* In-den-Warenkorb-Knöpfe des Themes: Produktseite (product-form), Leiste (form-Attribut),
     Produktkarten und Schnellkauf (product-card). Erfolg = PUB_SUB cartUpdate oder mehr Artikel
     im neu gezeichneten Warenkorb; Fehler = PUB_SUB cartError oder Anfrage beendet ohne Erfolg. */
  var ADD_FORMULAR = 'form[data-type="add-to-cart-form"], form.product-card__add-to-cart--form';
  var laufend = [];

  function themeKnoepfeFertig() {
    var liste = laufend;
    laufend = [];
    liste.forEach(function (e) {
      e.fertig = true;
      if (e.beobachter) e.beobachter.disconnect();
      window.clearTimeout(e.notbremse);
      if (e.knopf.isConnected) knopfZustand(e.knopf, 'fertig');
    });
  }

  function themeKnopfZurueck(e) {
    if (e.fertig) return;
    e.fertig = true;
    laufend = laufend.filter(function (x) {
      return x !== e;
    });
    if (e.beobachter) e.beobachter.disconnect();
    window.clearTimeout(e.notbremse);
    window.clearTimeout(e.nachlauf);
    if (e.knopf.isConnected) knopfZustand(e.knopf, null);
  }

  function istBeschaeftigt(b) {
    return !!(
      b &&
      (b.disabled ||
        b.getAttribute('aria-disabled') === 'true' ||
        b.classList.contains('loading') ||
        b.classList.contains('add-to-cart--is-disabled'))
    );
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches(ADD_FORMULAR)) return;
      var haupt = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
      var knopf = event.submitter && event.submitter.type === 'submit' ? event.submitter : haupt;
      if (!knopf || istBeschaeftigt(knopf) || (haupt && istBeschaeftigt(haupt))) return;

      aenderung++;
      var e = { knopf: knopf, haupt: haupt || knopf, fertig: false, warBeschaeftigt: false };
      laufend.push(e);
      knopfZustand(knopf, 'laedt');

      /* Ende der Anfrage erkennen: Das Theme nimmt am Formular-Knopf seine Sperre wieder weg. */
      if (typeof MutationObserver !== 'undefined') {
        e.beobachter = new MutationObserver(function () {
          if (istBeschaeftigt(e.haupt)) {
            e.warBeschaeftigt = true;
            return;
          }
          if (!e.warBeschaeftigt || e.fertig) return;
          window.clearTimeout(e.nachlauf);
          e.nachlauf = window.setTimeout(function () {
            themeKnopfZurueck(e);
          }, 900);
        });
        e.beobachter.observe(e.haupt, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
      }
      e.notbremse = window.setTimeout(function () {
        themeKnopfZurueck(e);
      }, 15000);
    },
    true
  );

  function pubSubVerbinden() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (daten) {
      if (daten && daten.source === 'rk-warenkorb') return;
      if (laufend.length) themeKnoepfeFertig();
    });
    subscribe(PUB_SUB_EVENTS.cartError, function (daten) {
      if (daten && daten.source === 'rk-warenkorb') return;
      laufend.slice().forEach(themeKnopfZurueck);
    });
  }

  /* ------------------------------------------------------------------ Druckzustand */

  var DRUCK_ZIELE = [
    'button[name="add"]',
    'button[name="checkout"]',
    '[data-rk-add]',
    '.rk-wa__knopf',
    '.product-card__add-to-cart--form [type="submit"]',
    '.quick-cart-drawer__trigger',
    '.shopify-payment-button__button',
    '[data-cart-link]',
    '.cart-drawer__action-buttons .button',
    '.cart__empty-button',
    '.rk-weiter-knopf',
    '.rk-entfernen__knopf',
    '.cart-item .quantity__button',
    '.rk-hinweis__schalter'
  ].join(',');

  var DRUCK = 'rk-gedrueckt';
  var gedrueckt = null;
  var gedruecktSeit = 0;

  function druckZiel(event) {
    var t = event.target;
    if (!t || typeof t.closest !== 'function') return null;
    var el = t.closest(DRUCK_ZIELE);
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return null;
    return el;
  }

  function druckAn(el) {
    if (gedrueckt && gedrueckt !== el) gedrueckt.classList.remove(DRUCK);
    gedrueckt = el;
    gedruecktSeit = Date.now();
    el.classList.add(DRUCK);
  }

  function druckAus() {
    if (!gedrueckt) return;
    var el = gedrueckt;
    gedrueckt = null;
    window.setTimeout(function () {
      if (el !== gedrueckt) el.classList.remove(DRUCK);
    }, Math.max(0, 140 - (Date.now() - gedruecktSeit)));
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      var el = druckZiel(event);
      if (el) druckAn(el);
    },
    { passive: true }
  );

  ['pointerup', 'pointercancel', 'dragstart'].forEach(function (typ) {
    document.addEventListener(typ, druckAus, { passive: true });
  });

  document.addEventListener('keydown', function (event) {
    if (event.repeat || (event.key !== 'Enter' && event.key !== ' ')) return;
    var el = druckZiel(event);
    if (el) druckAn(el);
  });

  document.addEventListener('keyup', druckAus);
  window.addEventListener('blur', druckAus);

  /* ------------------------------------------------------------------ Bestellhinweis */

  var hinweisWert = null; /* zuletzt getippt (null = unverändert seit Seitenaufruf) */
  var hinweisGespeichert = null; /* zuletzt erfolgreich gespeichert */
  var hinweisOffen = null; /* zuletzt auf-/zugeklappt */
  var hinweisTimer = null;

  function hinweisFelder() {
    return alle('[data-rk-hinweis-feld]');
  }

  function hinweisStatus(feld, text) {
    var box = feld.closest('[data-rk-hinweis]');
    var status = box ? box.querySelector('[data-rk-hinweis-status]') : null;
    if (status) status.textContent = text;
  }

  function hinweisTitel(wert) {
    alle('[data-rk-hinweis-titel]').forEach(function (t) {
      t.textContent = wert ? TEXT.hinweisAendern : TEXT.hinweisNeu;
    });
  }

  function hinweisSpeichern(feld) {
    window.clearTimeout(hinweisTimer);
    var wert = feld.value;
    if (wert === hinweisGespeichert) return;
    hinweisStatus(feld, '');
    postJson((routen().cart_update_url || '/cart/update') + '.js', { note: wert })
      .then(function (antwort) {
        if (!antwort.ok || antwort.json.status) throw new Error('note');
        hinweisGespeichert = wert;
        hinweisTitel(wert.trim());
        if (feld.value === wert) hinweisStatus(feld, TEXT.hinweisGespeichert);
      })
      .catch(function () {
        hinweisStatus(feld, TEXT.hinweisFehler);
      });
  }

  document.addEventListener('input', function (event) {
    var feld = event.target;
    if (!feld || !feld.matches || !feld.matches('[data-rk-hinweis-feld]')) return;
    hinweisWert = feld.value;
    hinweisFelder().forEach(function (f) {
      if (f !== feld) f.value = feld.value;
    });
    hinweisStatus(feld, '');
    window.clearTimeout(hinweisTimer);
    hinweisTimer = window.setTimeout(function () {
      hinweisSpeichern(feld);
    }, 900);
  });

  document.addEventListener(
    'change',
    function (event) {
      var feld = event.target;
      if (feld && feld.matches && feld.matches('[data-rk-hinweis-feld]')) hinweisSpeichern(feld);
    },
    true
  );

  /* toggle blubbert nicht – deshalb in der Capture-Phase */
  document.addEventListener(
    'toggle',
    function (event) {
      var box = event.target;
      if (box && box.matches && box.matches('[data-rk-hinweis]')) hinweisOffen = box.open;
    },
    true
  );

  function hinweiseWiederherstellen() {
    hinweisFelder().forEach(function (f) {
      if (hinweisWert !== null && f.value !== hinweisWert) f.value = hinweisWert;
      var box = f.closest('[data-rk-hinweis]');
      if (box && hinweisOffen !== null && box.open !== hinweisOffen) box.open = hinweisOffen;
    });
    if (hinweisWert !== null) hinweisTitel(hinweisWert.trim());
  }

  /* ------------------------------------------------------------------ Theme-Fix Kopf-Symbol */

  function zaehlerHuelle() {
    /* sectionsToRender ist eine globale let-Variable aus assets/cart.js */
    if (typeof sectionsToRender === 'undefined' || !Array.isArray(sectionsToRender)) return;
    var huelle = '#cart-counter > .header__utils-link--icon';
    if (!document.querySelector(huelle)) return;
    sectionsToRender.forEach(function (s) {
      if (s && s.section === 'cart-counter' && s.id === '#cart-counter') s.id = huelle;
    });
  }

  /* ------------------------------------------------------------------ Start */

  /* Beim define() werden die schon vorhandenen Elemente sofort verbunden – das ist kein Neuzeichnen. */
  startphase = false;

  /* wartet selbst, bis assets/cart.js die Schublade definiert hat */
  renderPatch();

  function start() {
    schubladeBeobachten();
    pubSubVerbinden();
    zaehlerHuelle();
    var f = hinweisFelder()[0];
    if (f) hinweisGespeichert = f.value;
    /* Live-Region für Seiten ohne Warenkorb-Bereich vorab anlegen – frisch eingefügte Regionen
       verschlucken Screenreader manchmal. */
    if (!document.querySelector('[data-rk-live="seite"]')) liveRegion();
  }

  /* Theme-Editor: neu geladene Abschnitte (z. B. die Schublade) wieder anbinden */
  document.addEventListener('shopify:section:load', function () {
    schubladeBeobachten();
    zaehlerHuelle();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    /* Deferred-Skripte laufen vor DOMContentLoaded – cart.js kann noch fehlen (Produktseite lädt
       dieses Skript vor der Schublade). Deshalb zusätzlich bei DOMContentLoaded. */
    document.addEventListener('DOMContentLoaded', zaehlerHuelle);
    window.setTimeout(start, 0);
  }

  /* Für andere Teile des Themes (z. B. die Merkliste, Paket B): in den Warenkorb legen und den
     Warenkorb des Themes neu zeichnen – öffnet die Schublade wie der Kaufen-Knopf.
     window.rkWarenkorb.hinzufuegen(variantenId, menge, { titel, ausloeser }) → Promise { ok, json, meldung } */
  RK.hinzufuegen = function (variantenId, menge, optionen) {
    return inDenWarenkorb(parseInt(variantenId, 10), parseInt(menge, 10) || 1, optionen || {});
  };
  RK.ansagen = ansagen;
})();
